import React from 'react';
import '../styles/whoweare.css'
import AnimationBox from '../animationBox';
import AnimatedArrowButton from './AnimatedArrowButton';
import myvideo from '../assets/whoweare.mp4'
import circle from '../assets/faqs-circle.png'

const WhoWeAre = () => {

    return(<div className='whoweare'>

        <AnimationBox>
            <div className='whoweare-outer' >
            <div className='whoweare-inner' >
            
            <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        
                        <h4 style={{color:'#FFD52B'}}>Who We Are</h4>
                        
            </div>
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"25px"}}>
                        
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between'}}><h1 style={{fontWeight:"600"}}>Building Intelligent Systems <br></br> for a Smarter Future</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="/Robotics-AboutUs"   /></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>At Company Six Robotics, we specialize in designing tailor-made automation solutions that enhance efficiency and adaptability in diverse industries. From turnkey systems to cutting-edge robotics, we bring your vision to life.</p>
                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="/Robotics-AboutUs"   /></div> 
                        </div>
            </div>
            <div style={{display:'flex', alignItems:'center',justifyContent:'center'}}>
            <div className='whowearevideo' style={{width:'90%', height:'17rem'  ,overflow:"hidden", borderRadius:'8px'}}>
            <video autoPlay muted loop style={{objectFit:'cover'}}>
             <source src={myvideo} type="video/mp4" /></video>
            
            </div>
            </div>

            </div>
            </div>
        </AnimationBox>
    

    </div>);

}

export default WhoWeAre;